import Bowser from 'bowser';
import { IPAD_MIN_TOUCH_POINTS, MAC_OS_NAME, TOUCH_PLATFORM_TYPES } from './constants/device';

export const isMobileOrTabletDevice = (): boolean => {
    const parser = Bowser.getParser(window.navigator.userAgent);
    if (TOUCH_PLATFORM_TYPES.includes(parser.getPlatformType())) return true;
    return parser.getOSName() === MAC_OS_NAME && window.navigator.maxTouchPoints >= IPAD_MIN_TOUCH_POINTS;
};
